export class InvoiceEntryCancel {
  constructor(public uuid: string, public quantityToCancel: number) {}
}
